import React, { FC } from 'react';
import { isGuestAlreadyInArray, getGuestGenderByTitle } from '@utils/helpers';
import { GuestLabel } from './GuestLabel';
import { GuestPill } from './GuestPill';
import { displayedGuests } from './utils';
import { PillWrapper, AddExistingGuestsWrapper } from './AddExistingGuests.styles';
import { MappedGuest } from '../../types';
import { some } from '@utils/some';

export type AddExistingGuestsProps = {
  selectedGuests: MappedGuest[];
  existingGuests: MappedGuest[];
  isGenderSpecific?: string | boolean;
  guest: MappedGuest;
  withTopMargin?: boolean;
  handleGuestPillClick: ({ guest }: { guest: MappedGuest }) => void;
};

export const AddExistingGuests: FC<AddExistingGuestsProps> = ({
  selectedGuests,
  existingGuests = [],
  guest,
  isGenderSpecific = false,
  withTopMargin = false,
  handleGuestPillClick,
}) => {
  const availableGuests = existingGuests.map((aGuest) => ({
    ...aGuest,
    gender: aGuest.gender || getGuestGenderByTitle(guest?.title),
  }));

  return some(displayedGuests(availableGuests, isGenderSpecific)) ? (
    <AddExistingGuestsWrapper withTopMargin={withTopMargin}>
      <div>
        <PillWrapper>
          {displayedGuests(availableGuests, isGenderSpecific).map((singleGuest, index) => {
            return (
              <GuestPill
                key={index}
                isActive={isGuestAlreadyInArray(selectedGuests, singleGuest)}
                onClick={() => handleGuestPillClick({ guest: singleGuest })}
                label={<GuestLabel guest={singleGuest} />}
              />
            );
          })}
        </PillWrapper>
      </div>
    </AddExistingGuestsWrapper>
  ) : null;
};
